<template>
  <div class="flex-column hp-10 px-7" :class="`step${currentStepNumber}`">
      <slot name="header"/>
      <slot name="content">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
      </slot>
      <slot name="footer">
            <stepper-indicator 
                :nbStep="nbStep" 
                :currentStepNumber="currentStepNumber">
            </stepper-indicator>
      </slot>
  </div>
</template>

<script>
import StepperIndicator from 'vcomponents/utilities/StepperIndicator.vue'
export default {
    name: 'StepperTemplate',
    props: {
        nbStep: {
            type: Number,
            required: true,
        },
        currentStepNumber: {
            type: Number,
            required: true,       
        },
    },
    components: {
        StepperIndicator
    }
}
</script>
